(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Detect grid column count and set data-promo-layout on the grid
  // so CSS can show the correct banner set (2col / 3col / 4col).
  function applyPromoLayout(grid) {
    const cols = window.getComputedStyle(grid).gridTemplateColumns.split(' ').length;
    const layout = cols >= 5 ? '5col' : cols >= 4 ? '4col' : cols >= 3 ? '3col' : '2col';
    grid.setAttribute('data-promo-layout', layout);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const grids = document.querySelectorAll('[data-testid="product-grid"]');
    grids.forEach(grid => {
      applyPromoLayout(grid);
      new ResizeObserver(() => applyPromoLayout(grid)).observe(grid);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
